import React, { useState, useEffect } from 'react';
import { MapPin, RefreshCw, User, Clock } from 'lucide-react';

export default function KioskHeader({ user, venue, onRefresh, refreshing }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const time = now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  const date = now.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });

  return (
    <header className="flex items-center justify-between gap-6 px-6 py-4 border-b border-white/10 bg-[#0d0d0f]">
      <div className="flex items-center gap-4 min-w-0">
        <div className="w-11 h-11 shrink-0 border border-primary/40 bg-primary/10 flex items-center justify-center">
          <Clock className="w-5 h-5 text-primary" />
        </div>
        <div className="min-w-0">
          <h1 className="text-white font-black text-xl uppercase tracking-tight leading-none truncate">
            Venue Check-In &amp; Rig Dispatch
          </h1>
          <p className="text-white/40 text-[11px] font-bold tracking-widest mt-1.5 flex items-center gap-1.5">
            <MapPin className="w-3 h-3" /> {venue}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-6 shrink-0">
        <div className="text-right">
          <p className="text-white font-mono font-black text-2xl leading-none tabular-nums">{time}</p>
          <p className="text-white/40 text-[10px] font-bold tracking-widest mt-1 uppercase">{date}</p>
        </div>
        <div className="flex items-center gap-2 border-l border-white/10 pl-6">
          <User className="w-4 h-4 text-white/40" />
          <div>
            <p className="text-white text-sm font-bold leading-none">{user?.full_name || 'Staff'}</p>
            <p className="text-white/30 text-[10px] font-bold tracking-widest mt-1 uppercase">Signed in</p>
          </div>
        </div>
        <button
          onClick={onRefresh}
          disabled={refreshing}
          className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/15 text-white font-bold text-xs tracking-widest px-5 py-3.5 transition-colors disabled:opacity-50"
        >
          <RefreshCw className={`w-4 h-4 ${refreshing ? 'animate-spin' : ''}`} />
          REFRESH
        </button>
      </div>
    </header>
  );
}